const showSavedJobsCountAnimation = (config = {}) => {
	const complete = config.complete || null;
	const opacity = config.show ? 1 : 0;
	const savedItems = document.querySelector('.saved-jobs-items');

	if (savedItems) {
        Velocity(
            savedItems,
            {
                opacity: opacity,
            },
            {
                duration: 150,
                complete: complete,
            }
        );
    }
};

export default showSavedJobsCountAnimation;